import { useEffect } from 'react';
import API from '../api/axios';

const CustomCodeInjector = () => {
 useEffect(() => {
 API.get('/custom-code').then(res => {
 const data = res.data.data;
 if (!data) return;

 if (data.custom_css) {
 const style = document.createElement('style');
 style.id = 'custom-site-css';
 style.textContent = data.custom_css;
 document.head.appendChild(style);
 }

 if (data.custom_js) {
 const script = document.createElement('script');
 script.id = 'custom-site-js';
 script.textContent = data.custom_js;
 document.body.appendChild(script);
 }
 }).catch(() => {});
 }, []);

 return null;
};

export default CustomCodeInjector;
